import React from "react";

export function BRookIcon({ color = "#5F5955" }: { color?: string }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 109 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: "middle" }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7745 46.1553C46.3169 43.3584 63.9786 43.9707 81.2019 46.1553ZM13.605 5.5178C9.59875 38.6529 17.7776 45.8718 27.7745 46.1553L15.2416 114.788H93.731L81.2019 46.1553C91.1988 45.8756 99.3701 38.6529 95.3676 5.5178L81.731 3.51465L77.6756 17.2872L65.8003 16.9093L63.8274 2.72095H45.1376L43.1723 16.9093L31.2932 17.2872L27.2378 3.51843L13.605 5.5178Z"
        fill={color}
      />
      <path
        d="M27.7745 46.1553C46.3169 43.3584 63.9786 43.9707 81.2019 46.1553M27.7745 46.1553C17.7776 45.8718 9.59875 38.6529 13.605 5.5178L27.2378 3.51843L31.2932 17.2872L43.1723 16.9093L45.1376 2.72095H63.8274L65.8003 16.9093L77.6756 17.2872L81.731 3.51465L95.3676 5.5178C99.3701 38.6529 91.1988 45.8756 81.2019 46.1553M27.7745 46.1553L15.2416 114.788H93.731L81.2019 46.1553"
        stroke={color}
        strokeWidth="4.53543"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.4882 106.79C54.4882 106.79 19.9811 106.972 10.3017 112.913C3.77449 116.919 2.23244 126.708 3.12063 136.811H105.856C106.744 126.712 105.206 116.916 98.6747 112.909C88.9991 106.975 54.4882 106.79 54.4882 106.79Z"
        fill={color}
        stroke={color}
        strokeWidth="4.53543"
        strokeLinejoin="round"
      />
    </svg>
  );
}
